<template lang='pug'>
  .fpui-dropdown-options(@click='stop')
    slot
</template>

<script>

export default {
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
    stop (e) { e.stopPropagation() },
    close () {
      if (typeof this.$parent.close === 'function') {
        this.$parent.close()
      }
    }
  }
}
</script>

<style lang='less'>
.fpui-dropdown-options {
  display: none;
  position: fixed;
  margin-top: 0;
  background: white;
  z-index: 100;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
}
</style>
